import { act, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useMutation, useQuery } from "react-query";
import { mdlTablePagination } from "../../../models/ui-models/TablePagination";
import { PageHeaderSection } from "../../../components/common/PageHeadSection";
import { Button, Skeleton, Steps } from "antd";
import { mdlHotelRoomDeleteRequest } from "../../../models/service-models/hotel/HotelRoomDeleteRequest";
import { toast } from "react-toastify";
import { ObjectHelper } from "../../../utils/ObjectHelper";
import { mdlHotelRoomListRequest } from "../../../models/service-models/hotel/HotelRoomListRequest";
import { mdlHotelRoomTypeListRequest } from "../../../models/service-models/hotel/HotelRoomTypeListRequest";
import { mdlHotelRoomAndTypeListRequest } from "../../../models/service-models/hotel/HotelRoomAndTypeListRequest";
import { RoomTable } from "../../../components/definitions/hotel/RoomTable";
import { CheckboxChangeEvent } from "antd/es/checkbox";
import _ from "lodash";
import { TabPanel } from "../../../components/elements/TabPanel";
import { RoomTypeTable } from "../../../components/definitions/hotel/RoomTypeTable";
import { RoomAndTypeTable } from "../../../components/definitions/hotel/RoomAndTypeTable";
import { HeaderButton } from "../../../models/ui-models/HeaderButton";
import { faCheck, faCopy, faFileExcel, faFilePdf, faLeftLong, faPlus, faRightLong, faSort } from "@fortawesome/free-solid-svg-icons";
import { SFModal } from "../../../components/elements/SFModal";
import { ExportModal } from "../../../components/common/ExportModal";
import { mdlIdCodeNamePair } from "../../../models/domain/IdCodeNamePair";
import { AddRoom } from "../../../components/definitions/hotel/AddRoom";
import { AddRoomType } from "../../../components/definitions/hotel/AddRoomType";
import { AddRoomAndType } from "../../../components/definitions/hotel/AddRoomAndType";
import { CopyRoomAndTypeToOtherHotels } from "../../../components/definitions/hotel/CopyRoomAndTypeToOtherHotels";
import { CopyRoomTypeToOtherHotels } from "../../../components/definitions/hotel/CopyRoomTypeToOtherHotels";
import { CopyRoomToOtherHotels } from "../../../components/definitions/hotel/CopyRoomToOtherHotels";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { RoomPriortySorter } from "../../../components/definitions/hotel/RoomPriortySorter";
import { mdlHotelRoomAndType } from "../../../models/domain/HotelRoomAndType";
import { DefinitionService } from "../../../services/DefinitionService";
import { enmExportModalType } from "../../../models/enums/ExportModalType";
import { mdlHotelRoomTypeDeleteRequest } from "../../../models/service-models/hotel/HotelRoomTypeDeleteRequest";
import { mdlHotelRoomAndTypeDeleteRequest } from "../../../models/service-models/hotel/HotelRoomAndTypeDeleteRequest";
import { mdlHotelRoomCreateRequest } from "../../../models/service-models/hotel/HotelRoomCreateRequest";
import { mdlHotelRoomTypeCreateRequest } from "../../../models/service-models/hotel/HotelRoomTypeCreateRequest";
import { mdlHotelRoomTypeCopyRequest } from "../../../models/service-models/hotel/HotelRoomTypeCopyRequest";
import { mdlHotelRoomCopyRequest } from "../../../models/service-models/hotel/HotelRoomCopyRequest";
import { mdlHotelRoomAndTypeCopyRequest } from "../../../models/service-models/hotel/HotelRoomAndTypeCopyRequest";
import { mdlHotelRoomAndTypeCreateRequest } from "../../../models/service-models/hotel/HotelRoomAndTypeCreateRequest";
import { mdlHotelRoomAndTypeUpdateRequest } from "../../../models/service-models/hotel/HotelRoomAndTypeUpdateRequest";
import { enmExcelExportType } from "../../../utils/ExcelColumnMappings";

export const RoomDefinition = () => {
    const { t } = useTranslation();
    const [autoFocus, setAutoFocus] = useState<string>();
    const [selectedHotel, setSelectedHotel] = useState<string>();
    const [roomCapacityList, setRoomCapacityList] = useState<mdlHotelRoomAndType[]>([]);
    const [roomListRequest, setRoomListRequest] = useState<mdlHotelRoomListRequest>({ pageNumber: 1, pageSize: 10 });
    const [roomTypeListRequest, setRoomTypeListRequest] = useState<mdlHotelRoomTypeListRequest>({ pageNumber: 1, pageSize: 10 });
    const [roomAndTypeListRequest, setRoomAndTypeListRequest] = useState<mdlHotelRoomAndTypeListRequest>({ pageNumber: 1, pageSize: 10 });
    const [selectedRoomList, setSelectedRoomList] = useState<string[]>([]);
    const [selectedRoomListFromRoomAndTypeAddNew, setselectedRoomListFromRoomAndTypeAddNew] = useState<string[]>([]);
    const [selectedRoomTypeList, setSelectedRoomTypeList] = useState<string[]>([]);
    const [selectedRoomAndTypeList, setSelectedRoomAndTypeList] = useState<string[]>([]);
    const [activeTab, setActiveTab] = useState<number>(0);
    const [buttons, setButtons] = useState<Array<HeaderButton>>([]);
    const [openModalAddNewRoom, setOpenModalAddNewRoom] = useState<boolean>(false);
    const [openModalAddNewRoomType, setOpenModalAddNewRoomType] = useState<boolean>(false);
    const [openModalAddNewRoomCapacity, setOpenModalAddNewRoomCapacity] = useState<boolean>(false);
    const [openModalCopyRoomAndTypesToOtherHotels, setOpenModalCopyRoomAndTypesToOtherHotels] = useState<boolean>(false);
    const [openModalCopyRoomTypesToOtherHotels, setOpenModalCopyRoomTypesToOtherHotels] = useState<boolean>(false);
    const [openModalCopyRoomsToOtherHotels, setOpenModalCopyRoomsToOtherHotels] = useState<boolean>(false);
    const [openModalExcelExportFromRoom, setOpenModalExcelExportFromRoom] = useState<boolean>(false);
    const [openModalExcelExportFromRoomType, setOpenModalExcelExportFromRoomType] = useState<boolean>(false);
    const [openModalExcelExportFromRoomAndType, setOpenModalExcelExportFromRoomAndType] = useState<boolean>(false);
    const [openModalPDFTableFromRoom, setOpenModalPDFTableFromRoom] = useState<boolean>(false);
    const [openModalPDFTableFromRoomType, setOpenModalPDFTableFromRoomType] = useState<boolean>(false);
    const [openModalPDFTableFromRoomAndType, setOpenModalPDFTableFromRoomAndType] = useState<boolean>(false);
    const [openSortModalToRoom, setOpenSortModalToRoom] = useState<boolean>(false);
    const [roomAndTypeCreateSelectedTypes, setRoomAndTypeCreateSelectedTypes] = useState<string | string[]>();
    const [editableRoomCapacity, setEditableRoomCapacity] = useState<mdlHotelRoomAndType>();

    useEffect(() => {
        if (!roomListData && selectedHotel)
            reFetchRoomList();

        if (!roomTypeListData && selectedHotel)
            reFetchRoomTypeList();

        if (!roomAndTypeListData)
            reFetchRoomAndTypeList();

        prepareButtons(undefined);
    }, [selectedHotel, activeTab]);

    //#region Hotel
    const handleHotelSelect = (hotelId: string) => {
        setSelectedRoomTypeList([]);
        setSelectedRoomList([]);
        setSelectedRoomAndTypeList([]);
        setSelectedHotel(hotelId);
    }
    //#endregion

    //region RoomTypeTable
    const copyHotelRoomType = useMutation({
        mutationFn: (data: mdlHotelRoomTypeCopyRequest) => {
            return DefinitionService.CopyHotelRoomType(data)
        }
    })

    const handleCopyRoomType = async (value: string | string[]) => {
        const _selectedRoomTypeList = roomTypeListData?.body?.data?.filter(x => selectedRoomTypeList.includes(x.id)).map((x: any) => x.roomTypeId.toString()) as string[];
        const result = await copyHotelRoomType.mutateAsync({ fromHotelId: selectedHotel, roomTypeIds: _selectedRoomTypeList, toHotelIds: value } as mdlHotelRoomTypeCopyRequest)
        if (result && result.body && result.body) {
            toast.success(t("common.success"));
            setOpenModalCopyRoomTypesToOtherHotels(false);
        } else {
            toast.error(ObjectHelper.getErrorMessage(result.header?.messages));
        }
    };
    const createHotelRoomType = useMutation({
        mutationFn: (data: mdlHotelRoomTypeCreateRequest) => {
            return DefinitionService.CreateHotelRoomType(data)
        }
    })

    const handleCreateRoomType = async (value: string | string[]) => {
        const result = await createHotelRoomType.mutateAsync({ hotelId: selectedHotel, roomTypeId: value } as mdlHotelRoomTypeCreateRequest)
        if (result && result.body && result.body) {
            toast.success(t("common.success"));
            reFetchRoomTypeList();
            setOpenModalAddNewRoomType(false);
        } else {
            toast.error(ObjectHelper.getErrorMessage(result.header?.messages));
        }
    };

    const addNewRoomType = () => {
        setOpenModalAddNewRoomType(true);
    };
    const copyRoomTypeToOtherHotels = () => {
        setOpenModalCopyRoomTypesToOtherHotels(true);
    };
    const exportToExcelFromRoomType = () => {
        setOpenModalExcelExportFromRoomType(true);
    }

    const exportToPdfFromRoomType = () => {
        setOpenModalPDFTableFromRoomType(true);
    };
    const {
        data: roomTypeListData,
        isLoading: isLoadingRoomType,
        refetch: reFetchRoomTypeList
    } = useQuery(
        ["getHotelRoomTypes", selectedHotel, roomTypeListRequest],
        () => {
            if (selectedHotel)
                return DefinitionService.HotelRoomTypeList({ ...roomTypeListRequest, hotelId: selectedHotel });
        },
        {
            refetchOnWindowFocus: false,
            enabled: !!selectedHotel
        }
    );


    const handleRoomTypeTableParamsChange = (pagination: mdlTablePagination, filters: any) => {
        setRoomTypeListRequest({ ...roomTypeListRequest, hotelId: selectedHotel, pageSize: pagination.pageSize ?? 10, pageNumber: pagination.current ?? 1 })
    }

    const handleDeleteRoomType = (roomTypeId: string) => {
        deleteRoomType({ id: roomTypeId, hotelId: selectedHotel });
    }
    const selectAllRoomType = (e: CheckboxChangeEvent) => {
        let _selectedRoomTypeList: string[] = [];
        if (e.target.checked) {
            _selectedRoomTypeList = roomTypeListData?.body?.data?.map((x) => x.id.toString()) as string[];
        }
        setSelectedRoomTypeList(_selectedRoomTypeList);
    }
    const { mutateAsync: deleteRoomType, isLoading: mutateLoadingRoomTypeDelete, data: mutateDataRoomTypeDelete } = useMutation(
        (request: mdlHotelRoomTypeDeleteRequest) => DefinitionService.DeleteHotelRoomType(request),
        {
            onMutate(variables) {
            },
            onError: error => {
                console.log(error);
            },
            onSuccess(data, variables, context) {
                if (data.header && data.header.success) {
                    toast.success(t("common.success"));
                    reFetchRoomList();
                    reFetchRoomAndTypeList();
                    reFetchRoomTypeList();
                }
                else {
                    toast.error(ObjectHelper.getErrorMessage(data.header.messages));
                }
            },
        }
    );
    const fnRoomTypeSelect = (e: CheckboxChangeEvent) => {
        let _selectedRoomTypeList = _.cloneDeep(selectedRoomTypeList);
        _selectedRoomTypeList = _.filter(_selectedRoomTypeList, function (x) { return x != e.target.value });
        if (e.target.checked) {
            _selectedRoomTypeList.push(e.target.value);
        }
        setSelectedRoomTypeList(_selectedRoomTypeList)
    }
    const fnRoomTypeActiveSelect = (id: string) => {
        let _selectedRoomTypeList = _.cloneDeep(selectedRoomTypeList);
        _selectedRoomTypeList = _.filter(_selectedRoomTypeList, function (x) { return x != id });
        _selectedRoomTypeList.push(id);
        setSelectedRoomTypeList(_selectedRoomTypeList)
    }

    const roomTypeTable = <RoomTypeTable
        onActiveItemSelect={fnRoomTypeActiveSelect}
        onTableItemSelect={fnRoomTypeSelect}
        onDelete={handleDeleteRoomType}
        pagination={{
            align: "center",
            current: roomTypeListData?.body?.pageNumber,
            pageSizeOptions: [10, 20, 50],
            defaultPageSize: 10,
            pageSize: roomTypeListRequest.pageSize,
            defaultCurrent: 1,
            responsive: true,
            showSizeChanger: true,
            total: roomTypeListData?.body?.totalPages,
            showTotal: (total: number, range: [number, number]) => t("pagination.total") + ` ${roomTypeListData?.body?.totalCount} ` + t("pagination.result"),
            locale: { items_per_page: "/ " + t("pagination.itemPerPage") }
        }}
        selectedRoomList={selectedRoomList}
        selectedRoomTypeList={selectedRoomTypeList}
        selectedHotel={selectedHotel}
        onHotelSelect={handleHotelSelect}
        onTableParamsChange={handleRoomTypeTableParamsChange}
        fnSelectAll={selectAllRoomType}
        tableItems={roomTypeListData?.body?.data} />
    //#endregion

    //#region  RoomTable
    const copyHotelRoom = useMutation({
        mutationFn: (data: mdlHotelRoomCopyRequest) => {
            return DefinitionService.CopyHotelRoom(data)
        }
    })

    const handleCopyRoom = async (value: string | string[]) => {
        const _selectedRoomType = roomListData?.body?.data?.filter(x => selectedRoomList.includes(x.id)).map((x: any) => x.roomId.toString()) as string[];
        const result = await copyHotelRoom.mutateAsync({ fromHotelId: selectedHotel, roomIds: _selectedRoomType, toHotelIds: value } as mdlHotelRoomCopyRequest)
        if (result && result.body && result.body) {
            toast.success(t("common.success"));
            setOpenModalCopyRoomsToOtherHotels(false);
        } else {
            toast.error(ObjectHelper.getErrorMessage(result.header?.messages));
        }
    };
    const createHotelRoom = useMutation({
        mutationFn: (data: mdlHotelRoomCreateRequest) => {
            return DefinitionService.CreateHotelRoom(data)
        }
    })

    const handleCreateRoom = async (value: string | string[]) => {
        const result = await createHotelRoom.mutateAsync({ hotelId: selectedHotel, roomId: value } as mdlHotelRoomCreateRequest)
        if (result && result.body && result.body) {
            toast.success(t("common.success"));
            reFetchRoomList();
            setOpenModalAddNewRoom(false);
        } else {
            toast.error(ObjectHelper.getErrorMessage(result.header?.messages));
        }
    };

    const addNewRoom = () => {
        setOpenModalAddNewRoom(true);
    };
    const copyRoomToOtherHotels = () => {
        setOpenModalCopyRoomsToOtherHotels(true);
    };
    const exportToExcelFromRoom = () => {
        setOpenModalExcelExportFromRoom(true);
    };
    const exportToPdfFromRoom = () => {
        setOpenModalPDFTableFromRoom(true)
    };
    const fnSortModalToRoom = () => {
        setOpenSortModalToRoom(true);
    };

    const {
        data: roomListData,
        isLoading: isLoadingRoom,
        refetch: reFetchRoomList
    } = useQuery(
        ["getHotelRooms", selectedHotel, roomListRequest],
        () => {
            if (selectedHotel)
                return DefinitionService.HotelRoomList({ ...roomListRequest, hotelId: selectedHotel });
        },
        {
            refetchOnWindowFocus: false,
            enabled: !!selectedHotel,
            onSuccess(data) {
                const _roomCapacityList = data?.body?.data?.map((elem: any) => (
                    {
                        id: elem.id,
                        adultNumber: elem.adultNumber,
                        roomName: elem.name,
                        roomId: elem.id,
                    } as mdlHotelRoomAndType
                ));
                setRoomCapacityList(_roomCapacityList ?? []);

            }
        }
    );

    const handleRoomTableParamsChange = (pagination: mdlTablePagination, filters: any) => {
        setRoomListRequest({ ...roomListRequest, hotelId: selectedHotel, pageSize: pagination.pageSize ?? 10, pageNumber: pagination.current ?? 1 })
    }

    const fnSelectEditNewFromRoomAndTypeToRoom = (id: string) => {
        let _selectedRoomList = _.cloneDeep(selectedRoomListFromRoomAndTypeAddNew);
        _selectedRoomList = _.filter(_selectedRoomList, function (x) { return x != id });
        _selectedRoomList.push(id);
        setselectedRoomListFromRoomAndTypeAddNew(_selectedRoomList);
    }

    const fnSelectAddNewFromRoomAndTypeToRoom = (e: CheckboxChangeEvent) => {
        let _selectedRoomList = _.cloneDeep(selectedRoomListFromRoomAndTypeAddNew);
        _selectedRoomList = _.filter(_selectedRoomList, function (x) { return x != e.target.value });
        if (e.target.checked) {
            _selectedRoomList.push(e.target.value);
        }
        setselectedRoomListFromRoomAndTypeAddNew(_selectedRoomList);
    }
    const selectAllRoomFromRoomAndTypeToRoom = (e: CheckboxChangeEvent) => {
        let _selectedRoomList: string[] = [];
        if (e.target.checked) {
            _selectedRoomList = roomListData?.body?.data?.map((x) => x.id.toString()) as string[];
        }
        setselectedRoomListFromRoomAndTypeAddNew(_selectedRoomList);
    }

    const handleDeleteRoom = (id: string, roomId: string) => {
        deleteRoom({ id: id, roomId: roomId, hotelId: selectedHotel });
    }
    const selectAllRoom = (e: CheckboxChangeEvent) => {
        let _selectedRoomList: string[] = [];
        if (e.target.checked) {
            _selectedRoomList = roomListData?.body?.data?.map((x) => x.id.toString()) as string[];
        }
        setSelectedRoomList(_selectedRoomList);
    }

    const { mutateAsync: deleteRoom, isLoading: mutateLoadingRoomDelete, data: mutateDataRoomDelete } = useMutation(
        (request: mdlHotelRoomDeleteRequest) => DefinitionService.DeleteHotelRoom(request),
        {
            onMutate(variables) {
            },
            onError: error => {
                console.log(error);
            },
            onSuccess(data, variables, context) {
                if (data.header && data.header.success) {
                    toast.success(t("common.success"));
                    reFetchRoomList();
                    reFetchRoomAndTypeList();
                    reFetchRoomTypeList();
                }
                else {
                    toast.error(ObjectHelper.getErrorMessage(data.header.messages));
                }
            },
        }
    );

    const fnRoomSelect = (e: CheckboxChangeEvent) => {
        let _selectedRoomList = _.cloneDeep(selectedRoomList);
        _selectedRoomList = _.filter(_selectedRoomList, function (x) { return x != e.target.value });
        if (e.target.checked) {
            _selectedRoomList.push(e.target.value);
        }
        setSelectedRoomList(_selectedRoomList)
    }

    const roomTable = <RoomTable
        onTableItemSelect={fnRoomSelect}
        onDelete={handleDeleteRoom}
        pagination={{
            align: "center",
            current: roomListData?.body?.pageNumber,
            pageSizeOptions: [10, 20, 50],
            defaultPageSize: 10,
            pageSize: roomListRequest.pageSize,
            defaultCurrent: 1,
            responsive: true,
            showSizeChanger: true,
            total: roomListData?.body?.totalPages,
            showTotal: (total: number, range: [number, number]) => t("pagination.total") + ` ${roomListData?.body?.totalCount} ` + t("pagination.result"),
            locale: { items_per_page: "/ " + t("pagination.itemPerPage") }
        }}
        selectedRoomList={selectedRoomList}
        selectedHotel={selectedHotel}
        onTableParamsChange={handleRoomTableParamsChange}
        fnSelectAll={selectAllRoom}
        tableItems={roomListData?.body?.data} />
    //#endregion

    //region RoomAndTypeTable
    const createHotelRoomAndType = useMutation({
        mutationFn: (data: mdlHotelRoomAndTypeCreateRequest) => {
            return DefinitionService.CreateHotelRoomAndType(data)
        }
    })
    const updateHotelRoomAndType = useMutation({
        mutationFn: (data: mdlHotelRoomAndTypeUpdateRequest) => {
            return DefinitionService.UpdateHotelRoomAndType(data)
        }
    })

    const handleRoomTypeOnSelected = (value: string | string[]) => {
        setRoomAndTypeCreateSelectedTypes(value);
    }

    const handleEditRoomCapacity = async (value: string | string[]) => {
        const _roomTypes = roomTypeListData?.body?.data?.filter(x => roomAndTypeCreateSelectedTypes?.includes(x.id)).map(
            (x: any) => ({
                roomTypeId: x.id,
                code: x.code,
                name: x.name,
                langId: x.langId,
                paximumId: x.paximumId
            }
            )
        )

        const roomAndTypeCounts = roomListData?.body?.data?.filter(x => selectedRoomListFromRoomAndTypeAddNew?.includes(x.id)).map(
            (x: any) => {
                const item = roomCapacityList.find(y => y.id == x.id);
                return {
                    id: x.id,
                    roomId: x.id,
                    roomName: x.name,
                    adults: parseInt(item?.adultNumber?.toString() ?? "0"),
                    maxAdults: parseInt(item?.adultNumber?.toString() ?? "0"),
                    minAdults: x.minAdults,
                    maxChilds: parseInt(item?.maxChilds?.toString() ?? "0"),
                    maxPax: parseInt(item?.maxChilds?.toString() ?? "0") + parseInt(item?.adultNumber?.toString() ?? "0"),
                    multi: 0
                }
            }
        )
        const request = {
            roomAndRoomTypeId: value,
            hotelId: selectedHotel,
            roomTypes: _roomTypes,
            roomAndTypeCounts: roomAndTypeCounts,
        } as mdlHotelRoomAndTypeUpdateRequest

        const result = await updateHotelRoomAndType.mutateAsync(request)
        if (result && result.body && result.body) {
            toast.success(t("common.success"));
            setOpenModalAddNewRoomCapacity(false);
            reFetchRoomAndTypeList();
        } else {
            toast.error(ObjectHelper.getErrorMessage(result.header?.messages));
        }
    };

    const handleCreateRoomCapacity = async (value: string | string[]) => {
        const _roomTypes = roomTypeListData?.body?.data?.filter(x => roomAndTypeCreateSelectedTypes?.includes(x.id)).map(
            (x: any) => ({
                roomTypeId: x.id,
                code: x.code,
                name: x.name,
                langId: x.langId,
                paximumId: x.paximumId
            }
            )
        )

        const roomAndTypeCounts = roomListData?.body?.data?.filter(x => selectedRoomListFromRoomAndTypeAddNew?.includes(x.id)).map(
            (x: any) => {
                const item = roomCapacityList.find(y => y.id == x.id);
                return {
                    id: x.id,
                    roomId: x.id,
                    roomName: x.name,
                    adults: parseInt(item?.adultNumber?.toString() ?? "0"),
                    maxAdults: parseInt(item?.adultNumber?.toString() ?? "0"),
                    minAdults: x.minAdults,
                    maxChilds: parseInt(item?.maxChilds?.toString() ?? "0"),
                    maxPax: parseInt(item?.maxChilds?.toString() ?? "0") + parseInt(item?.adultNumber?.toString() ?? "0"),
                    multi: 0
                }
            }
        )
        const request = {
            hotelId: selectedHotel,
            roomTypes: _roomTypes,
            roomAndTypeCounts: roomAndTypeCounts,
        } as mdlHotelRoomAndTypeCreateRequest

        const result = await createHotelRoomAndType.mutateAsync(request)
        if (result && result.body && result.body) {
            toast.success(t("common.success"));
            setOpenModalAddNewRoomCapacity(false);
            reFetchRoomAndTypeList();
        } else {
            toast.error(ObjectHelper.getErrorMessage(result.header?.messages));
        }
    };
    const handleCreateEditRoomCapacity = async (value: string | string[]) => {
        if (editableRoomCapacity && editableRoomCapacity.hotelId && editableRoomCapacity.roomTypeId) {
            setselectedRoomListFromRoomAndTypeAddNew([editableRoomCapacity.hotelId])
            value != undefined ? handleEditRoomCapacity(value) : handleCreateRoomCapacity(value);
        } else {
            value != undefined ? handleEditRoomCapacity(value) : handleCreateRoomCapacity(value);
        }
    };
    const copyHotelRoomAndType = useMutation({
        mutationFn: (data: mdlHotelRoomAndTypeCopyRequest) => {
            return DefinitionService.CopyHotelRoomAndType(data)
        }
    })

    const handleCopyRoomAndType = async (value: string | string[]) => {
        const result = await copyHotelRoomAndType.mutateAsync({ fromHotelId: selectedHotel, roomAndTypeIds: selectedRoomAndTypeList, toHotelIds: value } as mdlHotelRoomAndTypeCopyRequest)
        if (result && result.body && result.body) {
            toast.success(t("common.success"));
            setOpenModalCopyRoomTypesToOtherHotels(false);
        } else {
            toast.error(ObjectHelper.getErrorMessage(result.header?.messages));
        }
    };
    const handleEditToRoomCapacity = (record: mdlHotelRoomAndType) => {
        setEditableRoomCapacity(record);
        setRoomAndTypeCreateSelectedTypes(record.hotelRoomTypeId)
        setOpenModalAddNewRoomCapacity(true);
    };

    const addNewRoomCapacity = () => {
        setEditableRoomCapacity(undefined);
        setselectedRoomListFromRoomAndTypeAddNew([])
        setOpenModalAddNewRoomCapacity(true);
    };
    const copyRoomAndTypeToOtherHotels = () => {
        setOpenModalCopyRoomAndTypesToOtherHotels(true);
    };
    const exportToExcelFromRoomAndType = () => {
        setOpenModalExcelExportFromRoomAndType(true);
    };

    const exportToPdfFromRoomAndType = () => {
        setOpenModalPDFTableFromRoomAndType(true);
    };
    const {
        data: roomAndTypeListData,
        isLoading: isLoadingRoomAndType,
        refetch: reFetchRoomAndTypeList
    } = useQuery(
        ["getHotelRoomAndTypes", selectedHotel, roomAndTypeListRequest],
        () => {
            if (selectedHotel)
                return DefinitionService.HotelRoomAndTypeList({ ...roomAndTypeListRequest, hotelId: selectedHotel });
        },
        {
            refetchOnWindowFocus: false,
            enabled: !!selectedHotel
        }
    );

    const fnRoomAndTypeSelect = (e: CheckboxChangeEvent) => {
        let _selectedRoomAndTypeList = _.cloneDeep(selectedRoomAndTypeList);
        _selectedRoomAndTypeList = _.filter(_selectedRoomAndTypeList, function (x) { return x != e.target.value });
        if (e.target.checked) {
            _selectedRoomAndTypeList.push(e.target.value);
        }
        setSelectedRoomAndTypeList(_selectedRoomAndTypeList)
    }

    const deleteRoomAndType = useMutation({
        mutationFn: (request: mdlHotelRoomAndTypeDeleteRequest) => {
            return DefinitionService.DeleteHotelRoomAndType(request)
        }
    })

    const handleDeleteRoomAndType = async (roomAndTypeId: string) => {
        const result = await deleteRoomAndType.mutateAsync({ hotelId: selectedHotel, id: roomAndTypeId } as mdlHotelRoomAndTypeDeleteRequest)
        if (result.header && result.header.success) {
            toast.success(t("common.success"));
            reFetchRoomList();
            reFetchRoomAndTypeList();
            reFetchRoomTypeList();
        }
        else {
            toast.error(ObjectHelper.getErrorMessage(result.header.messages));
        }
    }
    const handleRoomAndTypeTableParamsChange = (pagination: mdlTablePagination, filters: any) => {
        setRoomAndTypeListRequest({ ...roomAndTypeListRequest, hotelId: selectedHotel, pageSize: pagination.pageSize ?? 10, pageNumber: pagination.current ?? 1 })
    }
    const selectAllRoomAndType = (e: CheckboxChangeEvent) => {
        let _selectedRoomAndTypeList: string[] = [];
        if (e.target.checked) {
            _selectedRoomAndTypeList = roomAndTypeListData?.body?.data?.map((x) => x.id.toString()) as string[];
        }
        setSelectedRoomAndTypeList(_selectedRoomAndTypeList);
    }
    const roomAndTypeTable = <RoomAndTypeTable
        onTableItemSelect={fnRoomAndTypeSelect}
        onDelete={handleDeleteRoomAndType}
        pagination={{
            align: "center",
            current: roomAndTypeListData?.body?.pageNumber,
            pageSizeOptions: [10, 20, 50],
            defaultPageSize: 10,
            pageSize: roomAndTypeListRequest.pageSize,
            defaultCurrent: 1,
            responsive: true,
            showSizeChanger: true,
            total: roomAndTypeListData?.body?.totalPages,
            showTotal: (total: number, range: [number, number]) => t("pagination.total") + ` ${roomAndTypeListData?.body?.totalCount} ` + t("pagination.result"),
            locale: { items_per_page: "/ " + t("pagination.itemPerPage") }
        }}
        selectedRoomList={selectedRoomList}
        selectedRoomTypeList={selectedRoomTypeList}
        selectedRoomAndTypeList={selectedRoomAndTypeList}
        selectedHotel={selectedHotel}
        onTableParamsChange={handleRoomAndTypeTableParamsChange}
        fnSelectAll={selectAllRoomAndType}
        onEdit={handleEditToRoomCapacity}
        tableItems={roomAndTypeListData?.body?.data} />


    const fnPrepareRoomCapacityList = (data: mdlHotelRoomAndType[]) => {
        setRoomCapacityList(data ?? []);
    }
    //#endregion

    const tabItems = [
        {
            label: t("definitions.hotels.roomType"),
            code: "roomType",
            display: true,
            content: roomTypeTable
        },
        {
            label: t("definitions.hotels.accommodationType"),
            code: "roomData",
            display: true,
            content: roomTable
        },
        {
            label: t("definitions.hotels.roomCapacityMatch"),
            code: "roomAndType",
            display: true,
            content: roomAndTypeTable
        }
    ];

    const fnSetAutoFocus = (key: string) => {
        setAutoFocus(key);
    }

    const fnChangeActiveTab = (index: number) => {
        setActiveTab(index);
        prepareButtons(index);
    };

    const fnPrev = () => {
        if (activeTab < 1)
            return;

        setActiveTab(activeTab - 1);
    };

    const fnNext = () => {
        if (activeTab > tabItems.length - 1)
            return;
        setActiveTab(activeTab + 1);
    };
    const fnComplete = () => {
        alert(t("common.complete"))
    };


    const prepareButtons = (index: number | undefined) => {
        if (index == undefined) {
            index = activeTab;
        }
        let _buttons: Array<HeaderButton> = [];
        if (index == 0) {
            _buttons.push({
                title: t("definitions.hotels.addNewRoomType"),
                icon: faPlus,
                fnFunction: addNewRoomType,
                className: "btn btn-white btn-dim btn-outline-primary"
            });
            _buttons.push({
                title: t("definitions.hotels.copyToOtherHotels"),
                icon: faCopy,
                fnFunction: copyRoomTypeToOtherHotels,
                className: "btn btn-white btn-dim btn-outline-primary"
            });
            _buttons.push({
                title: t("common.exportToExcel"),
                icon: faFileExcel,
                fnFunction: exportToExcelFromRoomType,
                className: "btn btn-white btn-dim btn-outline-primary"
            });
            _buttons.push({
                title: t("common.pdf"),
                icon: faFilePdf,
                fnFunction: exportToPdfFromRoomType,
                className: "btn btn-white btn-dim btn-outline-primary"
            });
            _buttons.push({
                title: t("definitions.hotels.roomPriorityTypeSorting"),
                icon: faSort,
                fnFunction: fnSortModalToRoom,
                className: "btn btn-white btn-dim btn-outline-primary"
            });
        } else if (index == 1) {
            _buttons.push({
                title: t("definitions.hotels.addNewAccommodationType"),
                icon: faPlus,
                fnFunction: addNewRoom,
                className: "btn btn-white btn-dim btn-outline-primary"
            });
            _buttons.push({
                title: t("definitions.hotels.copyToOtherHotels"),
                icon: faCopy,
                fnFunction: copyRoomToOtherHotels,
                className: "btn btn-white btn-dim btn-outline-primary"
            });
            _buttons.push({
                title: t("common.exportToExcel"),
                icon: faFileExcel,
                fnFunction: exportToExcelFromRoom,
                className: "btn btn-white btn-dim btn-outline-primary"
            });
            _buttons.push({
                title: t("common.pdf"),
                icon: faFilePdf,
                fnFunction: exportToPdfFromRoom,
                className: "btn btn-white btn-dim btn-outline-primary"
            });
        } else {
            _buttons.push({
                title: t("definitions.hotels.addNewRoomCapacity"),
                icon: faPlus,
                fnFunction: addNewRoomCapacity,
                className: "btn btn-white btn-dim btn-outline-primary"
            });
            _buttons.push({
                title: t("definitions.hotels.copyToOtherHotels"),
                icon: faCopy,
                fnFunction: copyRoomAndTypeToOtherHotels,
                className: "btn btn-white btn-dim btn-outline-primary"
            });
            _buttons.push({
                title: t("common.exportToExcel"),
                icon: faFileExcel,
                fnFunction: exportToExcelFromRoomAndType,
                className: "btn btn-white btn-dim btn-outline-primary"
            });
            _buttons.push({
                title: t("common.pdf"),
                icon: faFilePdf,
                fnFunction: exportToPdfFromRoomAndType,
                className: "btn btn-white btn-dim btn-outline-primary"
            });
        }
        setButtons(_buttons);
    };
    const items = tabItems.map((item) => ({ key: item.label, title: item.label }));

    return (
        <>
            <SFModal
                open={openModalAddNewRoom}
                toggler={() => { setOpenModalAddNewRoom(!openModalAddNewRoom) }}
                body={<AddRoom fnAddNew={handleCreateRoom} selectedHotel={selectedHotel} fnModalClose={() => setOpenModalAddNewRoom(!openModalAddNewRoom)} />}
                title={t("definitions.hotels.addNewRoom")}
            />
            <SFModal
                open={openModalAddNewRoomType}
                toggler={() => { setOpenModalAddNewRoomType(!openModalAddNewRoomType) }}
                body={<AddRoomType fnAddNew={handleCreateRoomType} selectedHotel={selectedHotel} fnModalClose={() => setOpenModalAddNewRoomType(!openModalAddNewRoomType)} />}
                title={t("definitions.hotels.addNewRoomType")}
            />
            <SFModal
                width={window.innerWidth * 50 / 100}
                open={openModalAddNewRoomCapacity}
                toggler={() => { setOpenModalAddNewRoomCapacity(!openModalAddNewRoomCapacity) }}
                body={<AddRoomAndType
                    fnActiveItemSelect={fnSelectEditNewFromRoomAndTypeToRoom}
                    activeItem={editableRoomCapacity}
                    onSelected={handleRoomTypeOnSelected}
                    selectedRoomListForAddNew={selectedRoomListFromRoomAndTypeAddNew}
                    onTableItemSelect={fnSelectAddNewFromRoomAndTypeToRoom}
                    fnSelectAll={selectAllRoomFromRoomAndTypeToRoom}
                    roomTypeList={roomTypeListData?.body?.data}
                    roomList={roomListData?.body?.data}
                    roomCapacityList={roomCapacityList}
                    fnPrepareRoomCapacityList={fnPrepareRoomCapacityList}
                    selectedHotel={selectedHotel}
                    fnModalClose={() => setOpenModalAddNewRoomCapacity(!openModalAddNewRoomCapacity)}
                    fnSetAutoFocus={fnSetAutoFocus}
                    autoFocus={autoFocus}
                    fnAddNew={handleCreateEditRoomCapacity}
                />}
                title={editableRoomCapacity?.id == undefined ? t("definitions.hotels.addNewRoomCapacity") : t("definitions.hotels.updateRoomCapacity")}
            />

            <SFModal
                open={openModalCopyRoomsToOtherHotels}
                toggler={() => { setOpenModalCopyRoomsToOtherHotels(!openModalCopyRoomsToOtherHotels) }}
                body={<CopyRoomToOtherHotels fnModalClose={() => setOpenModalCopyRoomsToOtherHotels(!openModalCopyRoomsToOtherHotels)} selectedHotel={selectedHotel} selectedRoomList={selectedRoomList} fnCopy={handleCopyRoom} onSelected={() => { }} />}
                title={t("definitions.hotels.copyToOtherHotels")}
            />

            <SFModal
                open={openModalCopyRoomTypesToOtherHotels}
                toggler={() => { setOpenModalCopyRoomTypesToOtherHotels(!openModalCopyRoomTypesToOtherHotels) }}
                body={<CopyRoomTypeToOtherHotels fnModalClose={() => setOpenModalCopyRoomTypesToOtherHotels(!openModalCopyRoomTypesToOtherHotels)} selectedHotel={selectedHotel} selectedRoomTypeList={selectedRoomTypeList} fnCopy={handleCopyRoomType} onSelected={() => { }} />}
                title={t("definitions.hotels.copyToOtherHotels")}
            />

            <SFModal
                open={openModalCopyRoomAndTypesToOtherHotels}
                toggler={() => { setOpenModalCopyRoomAndTypesToOtherHotels(!openModalCopyRoomAndTypesToOtherHotels) }}
                body={<CopyRoomAndTypeToOtherHotels fnModalClose={() => setOpenModalCopyRoomAndTypesToOtherHotels(!openModalCopyRoomAndTypesToOtherHotels)} selectedHotel={selectedHotel} selectedRoomAndTypeList={selectedRoomAndTypeList} fnCopy={handleCopyRoomAndType} onSelected={() => { }} />}
                title={t("definitions.hotels.copyToOtherHotels")}
            />
            <SFModal
                width={window.innerWidth * 30 / 100}
                open={openModalExcelExportFromRoom}
                toggler={() => { setOpenModalExcelExportFromRoom(!openModalExcelExportFromRoom) }}
                body={<ExportModal name="hotelRooms" excelExportType={enmExcelExportType.AccommodationType} data={roomListData?.body?.data} fnModalClose={() => setOpenModalExcelExportFromRoom(!openModalExcelExportFromRoom)} />}
                title={t("common.exportToExcel")}
            />
            <SFModal
                width={window.innerWidth * 30 / 100}
                open={openModalExcelExportFromRoomType}
                toggler={() => { setOpenModalExcelExportFromRoomType(!openModalExcelExportFromRoomType) }}
                body={<ExportModal name="hotelRoomTypes" excelExportType={enmExcelExportType.RoomType} data={roomTypeListData?.body?.data} fnModalClose={() => setOpenModalExcelExportFromRoomType(!openModalExcelExportFromRoomType)} />}
                title={t("common.exportToExcel")}
            />
            <SFModal
                width={window.innerWidth * 30 / 100}
                open={openModalExcelExportFromRoomAndType}
                toggler={() => { setOpenModalExcelExportFromRoomAndType(!openModalExcelExportFromRoomAndType) }}
                body={<ExportModal name="hotelRoomAndTypes" excelExportType={enmExcelExportType.RoomCapacity} data={roomAndTypeListData?.body?.data} fnModalClose={() => setOpenModalExcelExportFromRoomAndType(!openModalExcelExportFromRoomAndType)} />}
                title={t("common.exportToExcel")}
            />

            <SFModal
                width={window.innerWidth * 30 / 100}
                open={openModalPDFTableFromRoom}
                toggler={() => { setOpenModalPDFTableFromRoom(!openModalPDFTableFromRoom) }}
                body={<ExportModal excelExportType={enmExcelExportType.AccommodationType} name="hotelRooms" type={enmExportModalType.PDFTable} data={roomListData?.body?.data} fnModalClose={() => setOpenModalPDFTableFromRoom(!openModalPDFTableFromRoom)} />}
                title={t("common.exportToPDF")}
            />
            <SFModal
                width={window.innerWidth * 30 / 100}
                open={openModalPDFTableFromRoomType}
                toggler={() => { setOpenModalPDFTableFromRoomType(!openModalPDFTableFromRoomType) }}
                body={<ExportModal excelExportType={enmExcelExportType.RoomType} name="hotelRoomTypes" type={enmExportModalType.PDFTable} data={roomTypeListData?.body?.data} fnModalClose={() => setOpenModalPDFTableFromRoomType(!openModalPDFTableFromRoomType)} />}
                title={t("common.exportToPDF")}
            />
            <SFModal
                width={window.innerWidth * 30 / 100}
                open={openModalPDFTableFromRoomAndType}
                toggler={() => { setOpenModalPDFTableFromRoomAndType(!openModalPDFTableFromRoomAndType) }}
                body={<ExportModal excelExportType={enmExcelExportType.RoomCapacity} name="hotelRoomAndTypes" type={enmExportModalType.PDFTable} data={roomAndTypeListData?.body?.data} fnModalClose={() => setOpenModalPDFTableFromRoomAndType(!openModalPDFTableFromRoomAndType)} />}
                title={t("common.exportToPDF")}
            />
            <SFModal
                width={window.innerWidth * 30 / 100}
                open={openSortModalToRoom}
                toggler={() => { setOpenSortModalToRoom(!openSortModalToRoom) }}
                body={<RoomPriortySorter data={roomTypeListData?.body?.data} fnModalClose={() => { setOpenSortModalToRoom(!openSortModalToRoom); reFetchRoomTypeList() }} />}
                title={t("definitions.hotels.roomPriorityTypeSorting")}
            />
            <div className="nk-content ">
                <div className="container-fluid">
                    <div className="nk-content-inner">
                        <div className="nk-content-body">
                            <PageHeaderSection
                                pageTitle={t("definitions.hotels.title")}
                                buttons={buttons}
                                addNewFunction={undefined}
                            />
                            <div className="nk-block">
                                <div className="row g-gs">
                                    <div className="col-12">
                                        <div className="card card-bordered h-100">
                                            <div className="card-inner">
                                                <Steps current={activeTab} items={items} />
                                                <div className="py-4">
                                                    {
                                                        isLoadingRoom
                                                        &&
                                                        <>
                                                            <Skeleton active />
                                                            <Skeleton active />
                                                            <Skeleton active />
                                                        </>
                                                    }
                                                    <div >{tabItems[activeTab].content}</div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-sm-12 text-end">
                                                        <Button style={{ margin: '0 8px' }} onClick={() => fnPrev()} disabled={activeTab == 0}  >
                                                            {t("common.prev")}
                                                        </Button>
                                                        {
                                                            activeTab != tabItems.length - 1
                                                            &&
                                                            <Button type="primary" onClick={() => fnNext()} disabled={activeTab == tabItems.length - 1}>
                                                                {t("common.next")}
                                                            </Button>
                                                        }
                                                        {
                                                            activeTab == tabItems.length - 1
                                                            &&

                                                            <Button onClick={() => fnComplete()} disabled={!selectedRoomAndTypeList || selectedRoomAndTypeList.length == 0}>
                                                                {t("common.complete")}
                                                            </Button>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );


};
